import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../common/Button";
import { ReactComponent as ArrowNext } from "../../../../assets/icons/arrowrightwhite.svg";

// Owner-level roles from the backend IndComp.ROLE_CHOICES (app/company/models.py):
//   CL = Claimer (the person who claimed/owns the company), AD = Admin.
// Editors (ED) and any other / missing role are NOT owners.
export const OWNER_ROLES = ["CL", "AD"];
export const isOwnerRole = (role) => OWNER_ROLES.includes(role);

// TIP-489 (MV Stage 2a) — the company-profile purchase CTA. This is the old
// paid "Get Verified" button, repurposed: it reads "Get Membership" and routes
// to the reusable membership page (/membership/:companyId, TIP-488) instead of
// the legacy /payments verification-purchase flow. In the new model you buy a
// Membership; verification then becomes a free, member-only request (TIP-491),
// so this entry point must never read "Get Verified".
//
// Buying membership is a billing action, so it is owner-only: the button
// renders only for the company's Claimer or Admin. Everyone else (Editors,
// other roles, unlinked viewers) sees nothing here.
export const GetMembershipButton = ({ companyId, role, profileStatus }) => {
  const navigate = useNavigate();

  if (!isOwnerRole(role)) return null;
  // TIP-505 — the company is already a member (or verified, which implies
  // membership): there's nothing to purchase, so don't show the CTA.
  if (profileStatus === "member" || profileStatus === "verified") return null;

  const handleClick = () => {
    if (!companyId) return;
    window.scrollTo(0, 0);
    navigate(`/membership/${companyId}`);
  };

  return (
    <Button
      classes="flex items-center gap-2 rounded py-1 px-2 sm:py-2 sm:px-3 md:px-6 sm:test-f12 md:text-f16 text-[12px] font-semibold text-white bg-[#FB512D]"
      onClick={handleClick}
    >
      Get Membership
      <ArrowNext className="w-[18px] sm:w-auto h-[18px] sm:h-auto" />
    </Button>
  );
};

export default GetMembershipButton;
